import { useState } from "react";
import "../pages/styles/KebabVote.css"; // <-- make sure this path is correct

export default function VotePage() {
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");

  const VOTING_ENDED = true;
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (VOTING_ENDED) {
      setStatus("Balsavimas baigtas 🛑");
      return;
    }

    setStatus("Submitting...");

    try {
      const res = await fetch("https://worker.kebatic.org/vote", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Request failed");
      }

      setStatus("Vote submitted successfully!");
      setName("");
    } catch (err) {
      setStatus(err.message || "Something went wrong!");
    }
  };


  return (
    <div className="kebab-container">
      <div className="kebab-card">
        <h1 className="kebab-title">Balsuokit už kebabų Baroną</h1>

        <form onSubmit={handleSubmit}>
          <input
            className="kebab-input"
            type="text"
            placeholder="Balsavimas baigtas"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={VOTING_ENDED}
          />

          <button
            className="kebab-button"
            type="submit"
            disabled={true}
            title="Balsavimas baigtas"
          >
            Voting Closed
          </button>
        </form>

        {status && <p className="kebab-status">{status}</p>}
      </div>
    </div>
  );
}
